import { render, staticRenderFns } from "./CatalogoSubcausas.vue?vue&type=template&id=570df928&"
import script from "./CatalogoSubcausas.vue?vue&type=script&lang=js&"
export * from "./CatalogoSubcausas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports